<template>
    <div class="markers-container">
        <div class="markers-title">{{$l('graphs/markers')}}</div>
        <div class="markers-add-button" @click="addMarkerClicked"><icon  name="plus" ></icon></div>
        <div class="markers-close-button" @click="data.visible = false"><icon  name="close" ></icon></div>

        <div class="marker-item" v-for="marker in getLocalSettings.markers" v-bind:key="marker.id">
            <div class="marker-item-title" :class="{enabled:editingMarker == marker.id, activated:activeToggleMarkers[marker.id]==true}" >
                <div class="marker-click-hotspot" v-shortkey="[marker.keyCombo.modifier, marker.keyCombo.key]" @shortkey="markerClicked(marker.id)" v-if="editingMarker != marker.id" @click="markerClicked(marker.id)"></div>
                <div class="marker-color" v-bind:style="{backgroundColor: marker.color}"></div>
                <div class="marker-name">
                    <div v-if="editingMarker != marker.id">
                        {{marker.name}} 
                        <span class="marker-name-type">{{$l('graphs/markersCat/'+(marker.type?'toggle':'single'))}}</span>
                    </div>
                    <div  v-if="editingMarker == marker.id">
                        <el-input class="marker-name-input" size="small" v-model="marker.name"></el-input>
                        <div class="marker-name-input-line"></div>
                    </div>
                </div>
                <el-button class="marker-edit-button" v-if="editingMarker != marker.id" @click="editMarker(marker.id)" type="primary" size="mini" icon="edit"></el-button>
                <el-button class="marker-edit-button visible-button" v-if="editingMarker == marker.id" @click="editMarker(marker.id)" type="success" size="mini" icon="check"></el-button>
                

            </div>
            <el-collapse-transition>
                <div v-show="editingMarker == marker.id" class="marker-item-edit">
                    <el-row class="marker-item-edit-row">
                        <el-col :span="12" >
                             &nbsp;
                            <div class="marker-item-edit-title vertical-align">{{$l('graphs/markersCat/type')}}:</div>
                        </el-col>
                        <el-col :span="12" class="center-align">
                                {{$l('graphs/markersCat/single')}}
                                <el-switch
                                    v-model="marker.type"
                                    on-text=""
                                    off-text="">
                                </el-switch>
                                {{$l('graphs/markersCat/toggle')}}
                        </el-col>

                    </el-row>
                    <el-row class="marker-item-edit-row">
                        <el-col :span="12"  >
                             &nbsp;
                            <div class="marker-item-edit-title vertical-align">{{$l('graphs/markersCat/color')}}:</div>
                        </el-col>
                        <el-col :span="12" class="center-align">
                            
                                <el-color-picker class="marker-color-picker" v-model="marker.color"></el-color-picker>
                            
                        </el-col>
                    </el-row>
                    <el-row class="marker-item-edit-row">
                        <el-col :span="12"  >
                             &nbsp;
                            <div class="marker-item-edit-title vertical-align">{{$l('graphs/markersCat/keybind')}}:</div>
                        </el-col>
                        <el-col :span="12" class="center-align">
                                <!--<el-button size="mini" type="danger">{{$l('graphs/markersCat/learn')}}</el-button>-->
                                <el-row :gutter="10">
                                    <el-col :span="12">
                                        <el-select size="mini"  v-model="marker.keyCombo.modifier" filterable placeholder="Select">
                                            <el-option
                                                key="alt"
                                                :label="$l('graphs/markersCat/alt')"
                                                value="alt">
                                            </el-option>
                                            <el-option
                                                key="shift"
                                                :label="$l('graphs/markersCat/shift')"
                                                value="shift">
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-select size="mini"  v-model="marker.keyCombo.key" filterable placeholder="Select">
                                            <el-option
                                                v-for="key in keys"
                                                :key="key"
                                                :label="key"
                                                :value="key">
                                            </el-option>
                                            
                                        </el-select>
                                    </el-col>
                                </el-row>
                        </el-col>
                    </el-row>
                    <el-row class="marker-item-edit-row buttons">
                        <el-col :span="11" class="delete-button">
                            <el-button @click="deleteClicked(marker.id)"  size="small" icon="delete" type="danger">{{$l('graphs/markersCat/delete')}}</el-button>
                        </el-col>
                        <el-col :span="11" class="save-button">
                            <el-button @click="editMarker(marker.id)"  size="small" icon="check" type="success">{{$l('graphs/markersCat/save')}}</el-button>                            
                        </el-col>
                        
                        
                    </el-row>
                </div>
            </el-collapse-transition>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {saveLocalSettings} from '@/store/actions';

export default {
    props:['data'],
    computed:{
        ...mapGetters([
            'getLocalSettings'
        ])
    },
    data: function(){
        return {
            editingMarker: null,
            keys:[
                'a','b','c','č','d','e','f','g','h','i','j','k','l','m','n','o','p','r','s','š','t','u','v','z','ž','x','y','w','q','1','2','3','4','5','6','7','8','9','0','f1','f2','f3','f4','f5','f6','f7','f8','f9','f10','f11','f12',
            ],
            activeToggleMarkers:{}
        }
    },
    methods: {
        addMarkerClicked: function(){
            
            let markerId = new Date().getTime();

            let marker = {
                id: markerId, 
                type: false, //false - single, true - toggle
                name: 'New Marker',
                color: '#ff0066',
                keyCombo: {modifier:'alt', key:'1'},
            }

            this.getLocalSettings.markers.push(marker);
            saveLocalSettings(this.$store, this.$localStorage, this.getLocalSettings);
        },
        editMarker(markerId){
            saveLocalSettings(this.$store, this.$localStorage, this.getLocalSettings);
            if (this.editingMarker == markerId) {
                this.editingMarker = null;
                return;
            }   
            this.editingMarker = markerId;
        },
        deleteClicked: function(markerId){
            let marker = this.getLocalSettings.markers.find(a=>a.id==markerId);
            let markerIndex = this.getLocalSettings.markers.indexOf(marker);

            this.getLocalSettings.markers.splice(markerIndex, 1);
            saveLocalSettings(this.$store, this.$localStorage, this.getLocalSettings);
        },
        markerClicked: function(markerId){
            this.$emit('markerClicked', markerId, (enabled, realtime)=>{
                if (!realtime){
                    Object.keys(this.activeToggleMarkers).forEach(a=>{
                        this.activeToggleMarkers[a] = false;
                    })
                }
                this.activeToggleMarkers[markerId] = enabled;
                this.activeToggleMarkers = JSON.parse(JSON.stringify(this.activeToggleMarkers));
            });
        }
    }
}
</script>

<style scoped> 
  .markers-container{
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        min-width: 350px;
        position: relative;
    }
    .markers-title{
        text-align:center;
        font-size: 13px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        padding-bottom: 5px;
    }
    .markers-add-button{
        position: absolute;
        top:0px;
        left:0px;
    }
    .markers-add-button:hover{
        color:#1BBC9B;
    }
    .markers-close-button{
        position: absolute;
        top:0px;
        right:0px;
    }

    .markers-close-button:hover{
        color:#1BBC9B;
    }
    .marker-item{
        margin-top:10px;
        width: 100%;
        float: initial;
    }
    
    .marker-item-title{
        min-height:  20px;
        padding: 5px;
        cursor: pointer;
        padding-top:10px;
        border-radius: 4px;
        position: relative;
    }
    .marker-item-title:hover{
        background-color:rgba(0, 0, 0, 0.1);
    }
    .marker-item-title.enabled{
        background-color:rgba(0, 0, 0, 0.1);
    }

    .marker-item-title.activated{
        background-color:rgba(0, 0, 0, 0.2);
    }

    .marker-click-hotspot{
        position: absolute;
        background-color: rgba(0, 0, 0, 0.000001);
        top:0px;
        bottom:0px;
        left:0px;
        right:30px;
    }

    .marker-edit-button{
        position: absolute;
        right: 5px;
        top: 50%;
        transform: translateY(-50%);
        visibility: hidden;
        width: 25px;
    }
    .marker-item-title:hover>.marker-edit-button{
        visibility: visible;
    }

    .marker-color{
        float:left;
        width:15px;
        height:15px;
        border-radius: 50%;
        margin-right:5px;
    }
    .marker-name{
        float: left;
        padding-top: 2px;
        width: calc(100% - 50px);
        color:#000;
    }

    .marker-name-type{
        font-variant: small-caps;
        color:#444;
        font-size: 12px;
        margin-right: 5px;
        float: right;
    }

    .marker-item-edit{
        padding: 5px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        border-top: none;
        margin-top: -2px;
    }

    .marker-color-picker{
        transform: scale(0.6);
        margin-top: -5px;
    }

    .center-align{
        text-align: center;
    }

    .marker-item-edit-row{
        margin-top: 10px;
        padding: 5px;
        height: 35px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
    .marker-item-edit-title{
       margin-left: 5px;
    }
    .vertical-align{
         position: absolute;
         width: 100%;
        top:50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .marker-name-input{
       
        margin-top:-10px;
        width: 100%;
    }

    .marker-name-input-line{
        
        border-bottom:  1px solid rgba(0, 0, 0, 0.3);
        margin-top: -6px;
    }
    .visible-button{
        visibility: visible;
    }

    .buttons{
        border:none;
    }

    .delete-button{
        text-align: left;
    }

    .save-button{
        text-align: right;
    }
    
    
</style>

<style>
    .marker-name-input input{
        border:none;
        background-color: transparent;
        padding:0px;
        margin:0px;
        font-size: 12px;
        
    }
</style>



// WEBPACK FOOTER //
// MarkersPopover.vue?c44700f0